import React from 'react';
import CourseForm from '@components/courseForm/CourseForm';
import { useGetCurrentUserQuery } from '@teachur/http-client';
const EditCourse = () => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) {
    return null;
  }

  return <CourseForm course={{ id: -1 }} />;
};

export default EditCourse;
